import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { LessonContentState } from 'common.components/lesson-content/actions';

const getLessonContent = (store: any) => store.lessonContent as LessonContentState;

export const useLessonContentSelector: TypedUseSelectorHook<LessonContentState> = (selector, equalityFn) =>
    useSelector((store) => selector(getLessonContent(store)), equalityFn);
